import { render, staticRenderFns } from "./pickupManagement.vue?vue&type=template&id=396d0488&scoped=true"
import script from "./pickupManagement.vue?vue&type=script&lang=js"
export * from "./pickupManagement.vue?vue&type=script&lang=js"
import style0 from "./pickupManagement.vue?vue&type=style&index=0&id=396d0488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d0488",
  null
  
)

export default component.exports